export interface Article {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  excerpt: string;
  image: string;
  author: string;
  views: number;
  content: string;
  tags: string[];
  relatedArticles: number[];
}

export const articles: Record<number, Article> = {
  1: {
    id: 1,
    title: '英超新赛季前瞻：六大豪门实力分析与夺冠预测',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-05',
    excerpt: '2026-27赛季英超即将拉开帷幕，六大豪门经过夏季转会窗口的调整，实力格局是否发生改变？本文为您带来全面深入的分析。',
    image: 'https://readdy.ai/api/search-image?query=Premier%20League%20football%20stadium%20with%20players%20on%20pitch%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20green%20grass%20field%2C%20packed%20stadium%20atmosphere%2C%20action%20shot%2C%20editorial%20quality&width=1200&height=600&seq=art-01&orientation=landscape',
    author: '体育观察员',
    views: 12800,
    tags: ['英超', '足球', '赛季前瞻', '豪门', '转会'],
    content: `<p>2026-27赛季英超联赛即将于8月中旬全面打响。经过一个夏天的转会市场运作，六大传统豪门——曼城、阿森纳、利物浦、切尔西、曼联和热刺的阵容实力都发生了不同程度的变化。本文将为您带来全方位的赛季前瞻分析。</p>

<h2>曼城：王朝延续还是更新换代？</h2>
<p>作为过去五个赛季四夺冠军的绝对霸主，曼城在新赛季面临着前所未有的挑战。球队核心阵容年龄结构偏大，部分关键球员表达了离队意愿。然而，瓜迪奥拉的战术体系依旧领先于整个联赛，加上俱乐部在转会市场上的精准操作，曼城依然是新赛季夺冠的最大热门。</p>
<p>球队在夏窗引进了两名年轻的中场天才和一名速度型边锋，为阵容注入了新鲜血液。关键在于新援能否快速融入瓜帅的战术体系。如果磨合顺利，曼城依然具备统治联赛的实力。</p>

<h2>阿森纳：青年军能否更进一步？</h2>
<p>阿尔特塔麾下的阿森纳在上赛季展现了令人惊叹的进步，年轻的核心阵容经过两个赛季的磨合已趋于成熟。萨卡、厄德高、马丁内利组成的攻击线令人生畏。今夏球队在后防线和中场位置进行了针对性补强，阵容厚度得到显著提升。</p>
<p>阿森纳最大的优势在于球队的化学反应和战术执行力。如果能够保持上赛季的稳定性，并在关键比赛中展现出更强的心理素质，枪手极有可能终结长达二十余年的联赛冠军荒。</p>

<h2>利物浦：斯洛特时代的全新篇章</h2>
<p>利物浦进入了后克洛普时代，新帅斯洛特带来了更具控制力的战术风格。球队在保留核心框架的同时，对中场进行了彻底重组。索博斯洛伊和麦卡利斯特组成的中场双核已经展现了极强的统治力。</p>
<p>红军新赛季的成败很大程度上取决于锋线球员的健康状况和进球效率。如果萨拉赫能够延续巅峰状态，努涅斯能够提升射门转化率，利物浦将具备向冠军发起冲击的实力。</p>

<h2>切尔西：巨资投入能否换来回报？</h2>
<p>切尔西在伯利入主后持续在转会市场大举投入，球队阵容深度堪称英超之最。然而，庞大的阵容也带来了球员管理和战术磨合的难题。新赛季，蓝军需要在众多天才球员中找到最佳的组合方式。</p>
<p>球队的核心问题是缺乏一名真正的顶级射手。虽然中场创造力十足，但前锋线的终结能力始终令人担忧。如果这个问题得不到解决，切尔西可能再次陷入"得势不得分"的困境。</p>

<h2>曼联：滕哈格的关键赛季</h2>
<p>曼联在上赛季经历了跌宕起伏的征程，最终凭借足总杯冠军为赛季画上了相对圆满的句号。新赛季是滕哈格执教曼联的第三个赛季，也是决定其红魔生涯走向的关键一年。</p>
<p>球队在今夏进行了大刀阔斧的阵容调整，多名高薪低能的球员被清洗出队，取而代之的是更具活力和求胜欲望的新援。曼联能否在新赛季重返前四，乃至挑战更高目标，很大程度上取决于新援的融入速度。</p>

<h2>热刺：攻势足球的坚持与突破</h2>
<p>热刺在主教练的带领下坚持攻势足球理念，上赛季球队展现了极强的进攻火力，但防守端的问题同样突出。新赛季，球队在后防线进行了重要引援，旨在改善防守稳定性。</p>
<p>如果热刺能够在保持进攻锐度的同时提升防守质量，他们完全有能力打破传统六强格局，冲击欧冠资格。</p>

<h2>夺冠预测</h2>
<p>综合各队实力、阵容深度、战术体系成熟度以及赛程安排等因素，我们认为新赛季英超冠军将在曼城、阿森纳和利物浦三支球队之间产生。其中，阿森纳最有希望终结曼城的连冠势头，但前提是球队能够在整个赛季中保持稳定发挥。</p>`,
    relatedArticles: [2, 3, 6],
  },
  3: {
    id: 3,
    title: '法网决赛精彩回顾：德约科维奇再创历史纪录',
    category: '网球',
    categorySlug: 'tennis',
    date: '2026-08-03',
    excerpt: '德约科维奇在罗兰加洛斯再度封王，以惊人的状态击败新生代强敌，将个人大满贯冠军数量推至新的历史高度。',
    image: 'https://readdy.ai/api/search-image?query=French%20Open%20tennis%20match%20on%20clay%20court%2C%20professional%20player%20serving%2C%20Roland%20Garros%20stadium%2C%20dramatic%20sunlight%2C%20sports%20photography%2C%20orange%20clay%20surface%2C%20editorial%20quality&width=1200&height=600&seq=art-03&orientation=landscape',
    author: '网坛速递',
    views: 7600,
    tags: ['网球', '法网', '大满贯', '德约科维奇', '纪录'],
    content: `<p>在罗兰加洛斯的红土赛场上，塞尔维亚网球巨星诺瓦克·德约科维奇再次书写了属于自己的传奇篇章。面对新生代强力挑战者，德约科维奇以3-1的总比分（6-3、6-7、6-2、6-4）赢得决赛，将个人大满贯冠军总数提升至历史新高度。</p>

<h2>决赛进程：老将的沉稳与新星的冲击</h2>
<p>首盘比赛，德约科维奇迅速进入状态，凭借精准的底线击球和出色的发球表现，以6-3拿下。第二盘比赛中，年轻对手展现了惊人的韧性和攻击性，在抢七中以7-5扳回一城。</p>
<p>关键的第三盘，德约科维奇调整了战术策略，加强了上网频次和变线深度，以6-2大比分取胜，重新掌握主动权。第四盘双方展开激烈缠斗，德约科维奇在盘末阶段凭借丰富的经验和关键分把握能力，以6-4锁定胜利。</p>

<h2>历史意义：继续刷新纪录</h2>
<p>这场胜利使德约科维奇的大满贯冠军数量达到惊人的数字，在网球历史上遥遥领先。他不仅在三巨头时代结束后依然保持着顶级竞争力，更是在与新世代球员的对抗中证明了自己的长青传奇地位。</p>
<p>赛后，德约科维奇在颁奖典礼上动情表示："每一次站在这里，我都感到无比荣幸。这片红土场见证了我职业生涯中最艰难也最美好的时刻。感谢团队，感谢家人，感谢所有支持我的球迷。"</p>

<h2>技术统计：数据背后的统治力</h2>
<p>从技术统计来看，德约科维奇在这场决赛中展现了全面的技术优势：一发得分率高达78%，制胜分42个，非受迫性失误仅23个。在长达3小时15分钟的比赛中，这位老将的体能储备和专注力令人叹服。</p>

<h2>未来展望</h2>
<p>虽然德约科维奇的年纪已不再是秘密，但他在本赛季展现的竞技状态表明，传奇还远未到谢幕的时刻。随着美网和年终总决赛的临近，塞尔维亚人仍是各项赛事冠军的有力竞争者。</p>`,
    relatedArticles: [1, 4, 5],
  },
};

export const allArticlesList = [
  { id: 1, title: '英超新赛季前瞻：六大豪门实力分析与夺冠预测', category: '足球', categorySlug: 'football', date: '2026-08-05', excerpt: '2026-27赛季英超即将拉开帷幕，六大豪门经过夏季转会窗口的调整，实力格局是否发生改变？本文为您带来全面深入的分析。', image: 'https://readdy.ai/api/search-image?query=Premier%20League%20football%20stadium%20with%20players%20on%20pitch%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20green%20grass%20field%2C%20packed%20stadium%20atmosphere&width=800&height=500&seq=all-01&orientation=landscape', author: '体育观察员', views: 12800 },
  { id: 2, title: 'NBA自由市场大震荡：超级巨星去向分析与球队新格局', category: '篮球', categorySlug: 'basketball', date: '2026-08-04', excerpt: 'NBA自由球员市场开启后，多支球队完成重磅交易与签约。联盟势力版图正在发生剧变，新赛季竞争格局令人期待。', image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20action%20shot%2C%20player%20dunking%2C%20arena%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20sports%20photography&width=800&height=500&seq=all-02&orientation=landscape', author: '篮坛观察', views: 9600 },
  { id: 3, title: '法网决赛精彩回顾：德约科维奇再创历史纪录', category: '网球', categorySlug: 'tennis', date: '2026-08-03', excerpt: '德约科维奇在罗兰加洛斯再度封王，以惊人的状态击败新生代强敌，将个人大满贯冠军数量推至新的历史高度。', image: 'https://readdy.ai/api/search-image?query=French%20Open%20tennis%20match%20on%20clay%20court%2C%20professional%20player%20serving%2C%20Roland%20Garros%20stadium%2C%20dramatic%20sunlight&width=800&height=500&seq=all-03&orientation=landscape', author: '网坛速递', views: 7600 },
  { id: 4, title: 'LPL夏季赛季后赛赛程公布：八强争霸谁能问鼎', category: '电子竞技', categorySlug: 'esports', date: '2026-08-02', excerpt: '英雄联盟LPL夏季赛季后赛赛程正式公布，八支顶级战队将展开激烈角逐，争夺代表LPL出征世界赛的资格。', image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20gaming%20computers%20and%20large%20screens%2C%20professional%20gaming%20competition%2C%20colorful%20stage%20lighting&width=800&height=500&seq=all-04&orientation=landscape', author: '电竞先锋', views: 11200 },
  { id: 5, title: 'F1英国大奖赛：银石赛道上演速度与激情', category: '赛车', categorySlug: 'racing', date: '2026-08-01', excerpt: 'F1英国大奖赛在银石赛道上演精彩对决，排位赛意外频出，正赛策略博弈成为决定胜负的关键因素。', image: 'https://readdy.ai/api/search-image?query=Formula%201%20racing%20car%20on%20track%2C%20high%20speed%20motion%20blur%2C%20Silverstone%20circuit%2C%20professional%20motorsport%20photography&width=800&height=500&seq=all-05&orientation=landscape', author: '速度与激情', views: 5800 },
  { id: 6, title: '中超第20轮综述：争冠集团白热化，保级大战愈演愈烈', category: '足球', categorySlug: 'football', date: '2026-07-31', excerpt: '中超联赛第20轮战罢，争冠集团积分紧咬，三支球队仅差2分。保级区方面，多支球队陷入苦战，每一场比赛都至关重要。', image: 'https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20football%20match%2C%20players%20competing%20on%20field%2C%20professional%20stadium%20atmosphere%2C%20sports%20photography&width=800&height=500&seq=all-06&orientation=landscape', author: '中超观察', views: 4500 },
];